module.exports = __webpack_public_path__ + "static/media/Roller1.e27fac01.jpg";